import { Card, Stack } from '@mantine/core';
import React from 'react';

type SessionCardProps = {
  children: React.ReactNode;
  shadow?: 'xs' | 'sm' | 'md' | 'lg';
  radius?: 'sm' | 'md' | 'lg';
  withBorder?: boolean;
  p?: string | number;
  gap?: string | number;
  // Any other Card props
  [key: string]: any;
};

/**
 * SessionCard is a reusable card component for session details.
 * It wraps its children in a Mantine Card and Stack, providing consistent spacing and style.
 */
export const SessionCard: React.FC<SessionCardProps> = ({
  children,
  shadow = 'xs',
  radius = 'sm',
  withBorder = true,
  p = 'lg',
  gap = 'md',
  ...rest
}) => {
  return (
    <Card
      shadow={shadow}
      radius={radius}
      withBorder={withBorder}
      p={p}
      {...rest}
    >
      <Stack gap={gap}>{children}</Stack>
    </Card>
  );
};

// SessionInfoCard è ora disponibile come componente separato
// Importa da: ./SessionInfoCard/SessionInfoCard
